import { Map } from './components/map'

export { Map }
export default Map

export { Marker } from './components/marker'
export { Popup } from './components/popup'
export { AttributionControl } from './components/attribution-control'
export { FullscreenControl } from './components/fullscreen-control'
export { GeolocateControl } from './components/geolocate-control'
export { NavigationControl } from './components/navigation-control'
export { ScaleControl } from './components/scale-control'
export { TerrainControl } from './components/terrain-control'
export { LogoControl } from './components/logo-control'
export { Source } from './components/source'
export { CanvasSource } from './components/canvas-source'
export { Layer } from './components/layer'
export { useControl } from './components/use-control'
export { MapProvider, useMap } from './components/use-map'
export { DrawControl } from './components/draw-control'
export { GlobeControl } from './components/globe-control'
export {
  MinimapControl,
  Minimap,
  type MinimapControlOptions,
  type MinimapControlProps,
  type MinimapInteractions,
  type MapInteractions,
  type ParentRectConfig,
  type ToggleButtonConfig,
} from './components/minimap-control'

export type { MapProps } from './components/map'
export type { MapRef } from './maplibre/create-ref'
export type { MarkerProps } from './components/marker'
export type { PopupProps } from './components/popup'
export type { AttributionControlProps } from './components/attribution-control'
export type { FullscreenControlProps } from './components/fullscreen-control'
export type { GeolocateControlProps } from './components/geolocate-control'
export type { NavigationControlProps } from './components/navigation-control'
export type { ScaleControlProps } from './components/scale-control'
export type { TerrainControlProps } from './components/terrain-control'
export type { LogoControlProps } from './components/logo-control'
export type { SourceProps } from './components/source'
export type { CanvasSourceProps, CanvasCoordinates } from './components/canvas-source'
export type { LayerProps } from './components/layer'

// Re-export MapLayerMouseEvent for layer event typing
export type { MapLayerMouseEvent } from 'maplibre-gl'
export type { DrawControlProps, DrawControlOptions } from './components/draw-control'
export type { GlobeControlProps, GlobeControlOptions } from './components/globe-control'

export { logger, setLogger, type Logger } from './utils/logger'

// Types
export * from './types/common'
export * from './types/events'
export * from './types/lib'
export * from './types/style-spec'
